import { CogIcon } from "@cynthai/icons";
import { Eye, EyeSlash } from "iconsax-react";

import Button from "./Button";
import Dropdown from "./Dropdown";
import { m } from "./paraglide/messages";

export interface ColumnVisibilityDropdownProps {
  columns: string[];
  columnVisibility: Record<string, boolean>;
  onColumnVisibilityChange: (columnId: string, visible: boolean) => void;
}

export function ColumnVisibilityDropdown({
  columns,
  columnVisibility,
  onColumnVisibilityChange,
}: Readonly<ColumnVisibilityDropdownProps>) {
  const handleShowAll = () => {
    columns.forEach((col) => {
      if (!columnVisibility[col]) {
        onColumnVisibilityChange(col, true);
      }
    });
  };

  return (
    <Dropdown
      items={columns.map((column) => ({
        label: column,
        value: column,
        icon: columnVisibility[column] ? (
          <Eye
            size={16}
            className="stroke-text-primary"
            aria-label="Hide column"
          />
        ) : (
          <EyeSlash
            size={16}
            className="stroke-text-primary"
            aria-label="Show column"
          />
        ),
        iconPosition: "right" as const,
      }))}
      onAction={(key) => {
        onColumnVisibilityChange(String(key), !columnVisibility[String(key)]);
      }}
      header={
        <div
          className={`border-border text-text-primary flex items-center justify-between gap-10 border-b p-4 text-sm font-medium`}
        >
          <p>{m.show_columns()}</p>
          <Button
            size="sm"
            color="primary"
            variant="ghost"
            onClick={handleShowAll}
          >
            {m.show_all_columns()}
          </Button>
        </div>
      }
      closeOnAction={false}
      aria-label="Column visibility"
      className="w-fit max-w-[250px]"
    >
      <Button
        size="sm"
        color="tertiary"
        variant="ghost-bordered"
        icon={CogIcon}
        aria-label="column visibility"
      />
    </Dropdown>
  );
}
